module.exports = __webpack_public_path__ + "static/media/12-8.16a2e003.mp3";